import axios from "axios";

const { REACT_APP_SERVER_URL } = process.env;

export async function sendMessage(dat) {
  const sendQuery = await axios.post(`${REACT_APP_SERVER_URL}/messages`, dat);
  return sendQuery.data;
}